import React, { useMemo, useState, useEffect } from "react";
import { useLocation, useHistory, Redirect, Route, Switch } from "react-router-dom";
import { magicTokenFromSearch, searchWithoutMagic, followStagingRedirect, safeNext } from "helpers/emailLinks";
import { useDispatch, useSelector } from "react-redux";

import PersonalArea from "pages/PersonalArea";
import TimelinesPagePersonalArea from "pages/TimelinesPagePersonalArea";
import Viewer from "pages/TimelineViewer";
import SocketViewer from "pages/SocketViewer";
import Admin from "pages/Admin";
import UserProjects from "pages/UserProjects";
import TimelinePageAdmin from "pages/TimelinesPageAdmin";
import MainAdmin from "pages/MainAdmin";
import MainAdminProjects from "pages/MainAdminProjects";
import MainAdminPeople from "pages/MainAdminPeople";
import Authorization from "pages/Authorization";
import RegistrationUserAdmin from "pages/RegistrationUserAdmin";
import RegistrationUser from "pages/RegistrationUser";
import ResetPassword from "pages/ResetPassword";
import Share from "pages/Share";
// import LandingPageTemplate from "pages/LandingTemplate";
import Privacy from "pages/Privacy";
import RevitEstimate from "pages/RevitEstimate";

import { Maybe } from "helpers/maybeFunctor";
import "../pages/LandingTemplate/LandingTemplate.scss";

import "./App.scss";
import Header from "../components/Header";
import AppTopBars from "../components/Header/AppTopBars";
import { MDBBox } from "mdbreact";
import DownloadSoftwareModal from "../components/DownloadSoftwareModal";
import { googleAnalytics4 } from "../helpers/ga4Helper";
import Thankyou from "pages/Thankyou";
import Projects from "pages/configuration/projects";
import PricingCatelogs from "pages/PricingCatelogs";
import { ESTIMATING_DATABASE_ROUTES } from "pages/EstimatingDatabase";
import EstimationPage from "pages/Estimation/EstimationPage";
import MarketFeed from "pages/MarketFeed";
import Users from "pages/configuration/users";
import Milestones from "pages/configuration/milestones";
import Permissions from "pages/configuration/permisions";
import RequestAccess from "pages/configuration/requestAccess";
import Profile from "pages/Profile";
import UserPermissions from "pages/configuration/user_permissions";
import ModalHealthSetting from "pages/configuration/ModalHealth";
import ModalHealth from "pages/ModalHealth";
import ModalFileList from "pages/ModalHealth/ModalFileList/ModalFileList";
import ModelsPage from "pages/Models/ModelsPage";
import ExportSettings from "pages/configuration/exportSettings";
import Report from "pages/ModalHealth/Report";
import Parameters from "pages/Parameters";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import ModelViewer from "pages/ModelViewer";
import SplitSearchPage from "pages/SplitSearch/SplitSearchPage";
import MainAdminPermissions from "pages/MainAdmin/MainAdminPermissions";
import AdminFragments from "pages/AdminFragments/AdminFragments";
import EmailDeliveryPage from "pages/AdminEmail/EmailDeliveryPage";
import SharedDataPage from "pages/AdminShares/SharedDataPage";
import TimelinePage from "pages/Timeline/TimelinePage";
import ApprovalQueue from "pages/ApprovalQueue/ApprovalQueue";
import NotificationSettingsPage from "pages/Notifications/NotificationSettingsPage";
import NotificationPreferencesPage from "pages/Notifications/NotificationPreferencesPage";
import PlanBuilderPage from "pages/PlanBuilder/PlanBuilderPage";
import PartnersHub from "pages/Partners/PartnersHub";
import PartnerAdminPage from "pages/PartnerAdmin";
import CoordinationAreasPage from "pages/CoordinationAreas";
import SharedResourcePage from "pages/Shared/SharedResourcePage";
import BimDashboardPage from "pages/BimDashboard/BimDashboardPage";
import GlanceZonePage from "pages/BimDashboard/GlanceZonePage";
import EstimatesPage from "pages/Estimates/EstimatesPage";
import TechnicalDocumentationPage from "pages/Documentation/TechnicalDocumentationPage";
import AlignSheetPage from "pages/AlignSheet/AlignSheetPage";
import SchedulePrintPage from "pages/SchedulePrint/SchedulePrintPage";
import GanttPrintPage from "pages/SchedulePrint/GanttPrintPage";
import CoordinationIndexPage from "pages/BimDashboard/CoordinationIndexPage";
import TrackingPage from "pages/Tracking/TrackingPage";
import ShopDrawingsPage from "pages/ShopDrawings/ShopDrawingsPage";
import RfiPage from "pages/Rfi/RfiPage";
import ContractorHoursPage from "pages/ContractorHours/ContractorHoursPage";
import TrackingPrintPage from "pages/Tracking/TrackingPrintPage";
import ResponsibleRegistrationPage from "pages/ResponsibleRegistration/ResponsibleRegistrationPage";
import IssueViewerRedirect from "pages/Issue/IssueViewerRedirect";
import { setSidebarStatus } from "actions/user";
import AssetManagement from "pages/AssetManagement";
import AssetViewer from "pages/AssetManagement/AssetViewer";
import EstimationTemplate from "pages/EstimationTemplate";
import FilterView from "pages/FilterView";
import DocControl from "pages/DocControl";
import IssuePage from "pages/Issue/IssuePage";
import CreateIssuePage from "pages/Issue/CreateIssuePage";
import BatchIssueEntryPage from "pages/Issue/BatchIssueEntryPage";
import SchedulerPage from "pages/Scheduler/SchedulerPage";
import ProjectChecklistPage from "pages/Checklist/ProjectChecklistPage";
import BatchChecklistEntryPage from "pages/Checklist/BatchChecklistEntryPage";
import MinutesToPlanPage from "pages/MinutesToPlan/MinutesToPlanPage";
import ScheduleImportPage from "pages/ScheduleImport/ScheduleImportPage";
import ChecklistValidatePage from "pages/Checklist/ChecklistValidatePage";
import IssueResolutionPage from "pages/Issue/IssueResolutionPage";
import ExportHistoryPage from "pages/ExportHistory/ExportHistoryPage";
import ArchivedProjectsPage from "pages/PersonalArea/ArchivedProjectsPage";
import ProjectAnalyticsPage from "pages/ProjectAnalytics/ProjectAnalyticsPage";
import UserAnalyticsPage from "pages/ProjectAnalytics/UserAnalyticsPage";
import AnalyticsPerformancePage from "pages/Analytics/AnalyticsPerformancePage";
import DiffAnalyticsPage from "pages/ProjectAnalytics/DiffAnalyticsPage";
import DisciplineSettings from "pages/configuration/DisciplineSettings";
import RevisionSettings from "pages/configuration/RevisionSettings";
import Dashboard from "pages/Dashboard";
import ResourceTracking from "pages/ResourceTracking";
import MyApp from "learning/pages/_app";
import { tokenRef, url, setJWT, suspendedFlagRef } from "api";
import jwt_decode from "jwt-decode";
import { setUser } from "actions/user";
import SetPasswordNudge from "components/Auth/SetPasswordNudge";
// Coordination suite tab strip: mounted once under the header, shows
// itself only on coordination routes (see the component header).
import CoordinationTabBar from "components/Coordination/CoordinationTabBar";
import ActivityLog from "pages/ActivityLog/ActivityLog";
import Earnings from "pages/Earnings";
import Affiliations from "pages/configuration/Affiliations";
import CompanySettings from "pages/configuration/CompanySettings";
import { SupportChat } from "pages/Chat/SupportChat";

const App = (props) => {
  const dispatch = useDispatch();
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = allPermissionRedux
    ?.filter((element) => companyPermissionRedux?.includes(element))
    ?.filter((i) => usersPermissionRedux?.includes(i));
  const maybeEmail = Maybe.of(userInfoRedux).map(
    (userInfo) => userInfo.email
  ).value;

  const maybeUserID = Maybe.of(userInfoRedux).map(
    (userInfo) => userInfo.id
  ).value;
  const maybeMainAdmin = Maybe.of(userInfoRedux).map(
    (userInfo) => userInfo.admin
  ).value;
  const maybeAdmin = Maybe.of(userInfoRedux).map(
    (userInfo) => userInfo.companyAdmin
  ).value;

  const adminFlag = maybeMainAdmin || maybeAdmin;
  const [modal, setModal] = useState("");

  const location = useLocation();
  const history = useHistory();
  const socketviewer = location.pathname.startsWith("/socketviewer");

  // Magic-login links (?ml=<token>) — any page. Emailed links to
  // Responsible/partner accounts carry the token; swap it for a session
  // BEFORE any route renders (so the destination opens signed in and no
  // page runs its own exchange), then drop the parameter from the URL.
  // Fallback so the permission wait above can never hang forever.
  const [permsWaitExpired, setPermsWaitExpired] = useState(false);
  useEffect(() => {
    if (!maybeEmail) return undefined;
    // Long enough to cover initPermission's own three attempts (about
    // two seconds of waiting between them) plus a slow response on top.
    // At eight seconds the wait was expiring WHILE the retries were
    // still running, which is how a signed-in user ended up on the
    // authorization page during a refresh.
    const t = setTimeout(() => setPermsWaitExpired(true), 20000);
    return () => clearTimeout(t);
  }, [maybeEmail]);

  // The token is read wherever it sits: mail sent before 2026-10-12 put it
  // after a second '?' (helpers/emailLinks), where URLSearchParams never
  // found it and the partner met the login page.
  const [magicPending, setMagicPending] = useState(() => !!magicTokenFromSearch(window.location.search));
  useEffect(() => {
    const ml = magicTokenFromSearch(window.location.search);
    if (!ml) return;
    const cleanSearch = searchWithoutMagic(window.location.search);
    (async () => {
      try {
        const resp = await fetch(`${url}/users/magic-login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: ml, next: `${window.location.pathname}${cleanSearch}` }),
        });
        const body = await resp.json().catch(() => ({}));
        // Staging: a real person is sent to the same page on app.bidlight.com.
        if (followStagingRedirect(body)) return;
        // A paused login: the login page says why (api/index.js suspendedFlagRef).
        if (body && body.code === "login-paused") {
          try { sessionStorage.setItem(suspendedFlagRef, "paused"); } catch (e) { /* storage unavailable */ }
        }
        if (resp.ok && body.token) {
          localStorage.setItem(tokenRef, body.token);
          setJWT(body.token);
          // NO "SET A PASSWORD" NUDGE ANY MORE (owner, 2026-10-10: a partner
          // following a link must not be asked "to login or sign in or
          // provide information"). The card asked for a password and a phone
          // number 30 s after arrival; the flag that opened it is no longer
          // set, so SetPasswordNudge stays closed. A partner who wants a
          // password still has the login page's own route to one.
          sessionStorage.removeItem("bl_magic_needs_password");
          dispatch(setUser(jwt_decode(body.token)));
        }
      } catch (e) { /* fall through to the normal login flow */ }
      // Through the router, so every page reads the clean query (an
      // activity filter of "X?ml=..." matched nothing).
      try {
        history.replace({ pathname: window.location.pathname, search: cleanSearch, hash: window.location.hash });
      } catch { /* ignore */ }
      setMagicPending(false);
    })();
  }, []); // eslint-disable-line

  useEffect(() => {
    dispatch(setSidebarStatus(false));
  }, [location]);

  useEffect(() => {
    // LinkedIn Partner ID
    const partnerId = "3442420";

    // Add LinkedIn Insight Tag to the page
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      _linkedin_partner_id = "${partnerId}";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `;
    document.head.appendChild(script);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    script2.async = true;
    document.head.appendChild(script2);
  }, []);

  const pages = useMemo(() => {
    return (
      <div style={{ margin: "auto" }}>
        <Switch>
          <Route path="/privacy" exact component={Privacy} />
          <Route
            path="/Revit-Estimate-Plugin"
            exact
            component={RevitEstimate}
          />

          {/* IMPORTANT: use `render=` (NOT `component=`) when the
              route handler is an inline arrow function. React Router's
              `component` prop treats every render of the parent as a
              fresh component TYPE, which forces React to unmount +
              remount the child on every parent re-render. That bug
              under SocketViewer turned a single `adminDrillInFiredRef`
              into 200k+ admin-panel drill-in fetches per session
              (the ref is per-mount, so a remount loop defeats it),
              and the failed-fetch console.log storm was amplified
              by the desktop CefSharp diag pipe into a UI-thread
              freeze. `render=` keeps the child mounted across parent
              re-renders. See May-24 incident for the trace.
              Other inline-component routes in this file have the same
              latent issue — they're less visible because none have a
              failing-in-a-loop ref pattern, but they should be
              migrated to `render=` too. Tracked as a separate sweep. */}
          <Route
            path="/socketviewer/:projectId/:wsSessionId/:token/:companyId"
            exact
            render={({ match }) => (
              <SocketViewer
                companyId={match.params.companyId}
                projectId={match.params.projectId}
                wsSessionId={match.params.wsSessionId}
                token={match.params.token}
              />
            )}
          />
          <Route path="/dashboard" component={Dashboard} exact />
          <Route path="/personal-area" exact component={PersonalArea} />
          <Route path="/personal-area/projects/archived" exact component={ArchivedProjectsPage} />
          <Route path="/share-project/:shareId" exact component={Share} />
          <Route
            path="/personal-area/projects/:projectId/timelines"
            exact
            render={({ match }) => (
              <TimelinesPagePersonalArea projectId={match.params.projectId} />
            )}
          />
          <Route
            path="/personal-area/projects/:projectId/timelines/:timelineId"
            exact
            render={({ match }) => (
              <Viewer
                projectId={match.params.projectId}
                timelineId={match.params.timelineId}
                personal={true}
              />
            )}
          />
          <Route
            path="/personal-area/projects/:projectId/timelines/:timelineId/:token"
            exact
            render={({ match }) => (
              <Viewer
                projectId={match.params.projectId}
                timelineId={match.params.timelineId}
                token={match.params.token}
                personal={true}
              />
            )}
          />
          <Route
            path="/personal-area/projects/model-view/:projectId"
            exact
            render={({ match }) => (
              <ModelViewer projectId={match.params.projectId} />
            )}
          />

          <Route
            path="/main-admin/projects/:companyId/model-view/:projectId"
            exact
            render={({ match }) => (
              <ModelViewer projectId={match.params.projectId} companyId={match.params.companyId} />
            )}
          />

          {adminFlag ? (
            <Route
              path="/main-admin/users/:companyId"
              exact
              render={({ match }) => (
                <Admin companyId={match.params.companyId} />
              )}
            />
          ) : null}
          {adminFlag ? (
            <Route
              exact
              path="/main-admin/users/:companyId/:idUser"
              render={({ match }) => (
                <UserProjects idUser={match.params.idUser} />
              )}
            />
          ) : null}
          {adminFlag ? (
            <Route
              path="/main-admin/users/:companyId/:idUser/:project"
              exact
              render={({ match }) => (
                <TimelinePageAdmin projectId={match.params.project} />
              )}
            />
          ) : null}
          {maybeMainAdmin ? (
            <Route path="/main-admin" component={MainAdmin} exact />
          ) : null}
          {maybeMainAdmin ? (
            <Route
              path="/main-admin/projects/:idCompany"
              component={MainAdminProjects}
              exact
            />
          ) : null}
          {maybeMainAdmin ? (
            <Route
              path="/main-admin/people/:idCompany"
              component={MainAdminPeople}
              exact
            />
          ) : null}
          {maybeMainAdmin ? (
            <Route
              path="/main-admin/permissions/:idCompany"
              component={MainAdminPermissions}
              exact
            />
          ) : null}

          {maybeMainAdmin ? (
            <Route path="/admin/affiliations" component={Affiliations} exact />
          ) : null}
          {maybeMainAdmin ? (
            <Route path="/admin/fragments" component={AdminFragments} exact />
          ) : null}
          {maybeMainAdmin ? (
            <Route
              path="/admin/email-delivery"
              component={EmailDeliveryPage}
              exact
            />
          ) : null}
          {/* Shared data console: super admin AND company admin, so this
              gates on adminFlag rather than maybeMainAdmin. The route scopes
              a company admin to their own company. */}
          {adminFlag ? (
            <Route
              path="/admin/shared-data"
              component={SharedDataPage}
              exact
            />
          ) : null}
          {/* Contributors, Team Performance and Team Insights are folded
              into Analytics & Performance (/analytics); old links land there. */}
          {["/analytics/contributors", "/analytics/teams", "/team-insights"].map((from) => (
            <Route key={from} path={from} exact
              render={({ location }) => <Redirect to={{ pathname: "/analytics", search: location.search }} />} />
          ))}
          <Route path="/timeline" component={TimelinePage} exact />
          {/* Review Center is owner-side (proposals, triage, checklist
              sign-off, minutes, close). Partner tiers / the PartnerCompany
              ceiling never carry issueApproveResolution, so partners fall
              through to /dashboard - same gate the drawer link uses. */}
          {(FinalPermissions?.includes(ALL_PERMISSIONS.REVIEW_CENTER_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.REVIEW_CENTER_APPROVE) || FinalPermissions?.includes(ALL_PERMISSIONS.ISSUE_APPROVE_RESOLUTION)) && (
            <Route path="/approval-queue" component={ApprovalQueue} exact />
          )}
          {/* ONE PARTNERS VIEW (owner, 2026-10-16): the old account page and the
              old project roster both land in pages/Partners/PartnersHub. */}
          <Route path="/partners" component={PartnersHub} exact />
          <Route path="/partner-management" exact render={() => <Redirect to="/partners?view=all" />} />
          <Route path="/notifications-console" component={NotificationSettingsPage} exact />
          {/* Personal, not admin: every signed-in user reaches their own
              email preferences, and a project member can open a
              colleague's or a partner's from the same page. */}
          <Route path="/email-preferences" component={NotificationPreferencesPage} exact />
          <Route
            path="/plan-builder/:projectId"
            component={PlanBuilderPage}
            exact
          />
          <Route
            path="/scheduler/:projectId"
            component={SchedulerPage}
            exact
          />
          <Route
            path="/schedule-print/:projectId"
            component={SchedulePrintPage}
            exact
          />
          <Route
            path="/gantt-print/:projectId"
            component={GanttPrintPage}
            exact
          />
          {/* Field tracking (docs/tracking.md): what is installed, what is
              not, and where. The print view is the same shape as the two
              above - a plain page the browser prints. */}
          <Route
            path="/tracking-print/:projectId"
            component={TrackingPrintPage}
            exact
          />
          {/* 2D/3D split search (docs/2d-3d-search.md). One box, both
              worlds, no link table - the panes agree or they do not. */}
          <Route path="/split-search" component={SplitSearchPage} exact />
          <Route path="/checklists" component={ProjectChecklistPage} exact />
          {/* Batch entry for checklist items. Ungated like /checklists: the
              page disables saving without checklistAdd, and the route
              refuses it anyway. */}
          <Route path="/checklists/batch" component={BatchChecklistEntryPage} exact />
          <Route path="/minutes-to-plan" component={MinutesToPlanPage} exact />
          {/* Document import wizard (PDF minutes / CSV / Excel -> schedule,
              issues, checklists, minutes). Owner-side gate is server-side; the
              page itself redirects partners. */}
          <Route path="/schedule-import" component={ScheduleImportPage} exact />
          <Route path="/schedule-import/:projectId" component={ScheduleImportPage} exact />
          <Route
            path="/participants/:projectId"
            exact
            render={({ match }) => <Redirect to={`/partners?projectId=${match.params.projectId}`} />}
          />
          <Route
            path="/coordination"
            component={CoordinationIndexPage}
            exact
          />
          {/* Same shape as /areas: a bare path that opens on the
              remembered project, and a deep link that names one. */}
          <Route path="/align/:projectId" component={AlignSheetPage} exact />
          {/* Shop drawings, before Construction tracking in the menus
              (owner, 2026-09-24). Same shape as tracking: with a project
              and without. */}
          {/* CONTRACTOR HOURS AND COST, every billable system. Gated on
              adminFlag - super admin OR company admin - which is the same
              pair routes/billableHours enforces, so the app cannot offer a
              page the API will refuse. */}
          {adminFlag ? (
            <Route path="/contractor-hours" component={ContractorHoursPage} exact />
          ) : null}
          <Route path="/shop-drawings/:projectId" component={ShopDrawingsPage} exact />
          <Route path="/shop-drawings" component={ShopDrawingsPage} exact />
          {/* RFI Generator (owner, 2026-10-20): with a project and without,
              like the other coordination tabs. */}
          <Route path="/rfi/:projectId" component={RfiPage} exact />
          <Route path="/rfi" component={RfiPage} exact />
          <Route path="/tracking/:projectId" component={TrackingPage} exact />
          <Route path="/tracking" component={TrackingPage} exact />
          <Route
            path="/coordination/:projectId"
            component={BimDashboardPage}
            exact
          />
          {/* At a Glance zone detail, opened in a new tab from the stack;
              the view lives in the hash (#level=&zone=&sys=&two=). */}
          <Route path="/coordination/:projectId/zone" component={GlanceZonePage} exact />
          {/* Technical estimates (guide section 21) - owner company only. */}
          <Route path="/coordination/:projectId/estimates" component={EstimatesPage} exact />
          {/* Technical documentation: At a Glance first, then one tab per
              generated view (guide section 18). */}
          <Route path="/documentation/:projectId" component={TechnicalDocumentationPage} exact />
          <Route path="/documentation" component={TechnicalDocumentationPage} exact />
          {/* Backend notification links address issues by _id; the real
              viewer route is /issue/:shareToken — this resolves + redirects. */}
          <Route
            path="/issue-viewer/:issueId"
            component={IssueViewerRedirect}
            exact
          />
          {/* Checklist sign-off links in the digests open signed in (the
              ?ml= link signs the partner in first); the page existed only
              for signed-out visitors, so they fell through to /dashboard. */}
          <Route
            path="/checklist/validate/:token"
            exact
            render={({ match }) => (
              <ChecklistValidatePage token={match.params.token} />
            )}
          />
          {FinalPermissions?.includes(ALL_PERMISSIONS.PROJECT_VIEW) ? (
            <Route path="/admin/projects-settings" component={Projects} exact />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.USER_VIEW) ? (
            <Route path="/users" component={Users} exact />
          ) : null}
          {FinalPermissions?.includes(ALL_PERMISSIONS.MILESTONE_VIEW) ? (
            <Route path="/admin/milestones" component={Milestones} exact />
          ) : null}
          {FinalPermissions?.includes(
            ALL_PERMISSIONS.MODAL_HEALTH_SETTINGS_VIEW
          ) ? (
            <Route
              path="/admin/model-health-settings"
              component={ModalHealthSetting}
              exact
            />
          ) : null}
          {FinalPermissions?.includes(ALL_PERMISSIONS.DISCIPLINE_VIEW) ? (
            <Route
              path="/admin/discipline-settings"
              component={DisciplineSettings}
              exact
            />
          ) : null}
          {FinalPermissions?.includes(ALL_PERMISSIONS.REVISION_VIEW) ? (
            <Route
              path="/admin/revision-settings"
              component={RevisionSettings}
              exact
            />
          ) : null}
          {FinalPermissions?.includes(ALL_PERMISSIONS.PRICING_DATABASE_VIEW) ? (
            <Route
              path="/pricing-catalogues"
              component={PricingCatelogs}
              exact
            />
          ) : null}
          {/* Estimating database pages (Database drawer section), same
              permission as Pricing Catalogs. */}
          {FinalPermissions?.includes(ALL_PERMISSIONS.PRICING_DATABASE_VIEW)
            ? ESTIMATING_DATABASE_ROUTES.map((r) => (
                <Route key={r.path} path={r.path} component={r.component} exact />
              ))
            : null}
          {/* Estimation (the desktop estimating app, Rust/WASM) - its own permission */}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ESTIMATION) ? (
            <Route path="/estimation" component={EstimationPage} />
          ) : null}
          <Route path="/market-feed" component={MarketFeed} exact />
          {/* MODELS (owner 2026-10-21): /modal-file-list became /models - the
              project's model files from Procore / ACC; the old company-wide
              health-check file list lives on beside it. Old links redirect. */}
          {FinalPermissions?.includes(ALL_PERMISSIONS.MODAL_FILE_VIEW) ||
          FinalPermissions?.includes(ALL_PERMISSIONS.MODAL_HEALTH_REPORT_VIEW) ? (
            <Route path="/models" component={ModelsPage} exact />
          ) : null}
          {FinalPermissions?.includes(ALL_PERMISSIONS.MODAL_FILE_VIEW) ? (
            <Route path="/models/health-check-files" component={ModalFileList} exact />
          ) : null}
          <Route path="/modal-file-list" exact render={() => <Redirect to="/models" />} />
          {FinalPermissions?.includes(
            ALL_PERMISSIONS.MODAL_HEALTH_REPORT_VIEW
          ) ? (
            <Route path="/model-health" component={ModalHealth} exact />
          ) : null}
          {FinalPermissions?.includes(
            ALL_PERMISSIONS.MODAL_HEALTH_REPORT_VIEW
          ) ? (
            <Route
              path="/model-health/:reportId"
              exact
              render={({ match }) => (
                <Report reportId={match.params.reportId} />
              )}
            />
          ) : null}
          {FinalPermissions?.includes(ALL_PERMISSIONS.PARAMETER_MGMT_VIEW) ? (
            <Route path="/all-parameters" component={Parameters} exact />
          ) : null}

          {FinalPermissions?.includes(
            ALL_PERMISSIONS.PROJECT_EXPORT_SETTINGS_VIEW
          ) ? (
            <Route
              path="/admin/export-settings"
              component={ExportSettings}
              exact
            />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.USER_VIEW) ? (
            <Route
              path="/admin/user-permissions"
              component={UserPermissions}
              exact
            />
          ) : null}

          <Route
            path="/admin/partner-companies"
            component={PartnerAdminPage}
            exact
          />

          <Route path="/areas/:projectId" component={CoordinationAreasPage} exact />
          <Route path="/areas" component={CoordinationAreasPage} exact />

          <Route
            path="/admin/company-settings"
            component={CompanySettings}
            exact
          />

          <Route path="/admin/support-chat" component={SupportChat} exact />

          {FinalPermissions?.includes(ALL_PERMISSIONS.ASSET_MANAGEMENT_VIEW) ? (
            <Route
              path="/assets-management"
              component={AssetManagement}
              exact
            />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.ASSET_MANAGEMENT_VIEW) ? (
            <Route
              path="/assets-management/asset-view/:projectId"
              exact
              render={({ match }) => (
                <AssetViewer projectId={match.params.projectId} />
              )}
            />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.FILTER_VIEW) ? (
            <Route path="/filter-view" component={FilterView} exact />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.DOC_CONTROL_VIEW) ? (
            <Route path="/document-control" component={DocControl} exact />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.ISSUE_VIEW) && (
            <Route path="/issues" component={IssuePage} exact />
          )}
          {/* Creating issues needs issueCreate (the server refuses
              POST /issue as well). Without it, /issue/new must NOT fall
              through to the /issue/:shareToken redirect below (it would
              land on a broken /issue/new/resolve) - send the person to
              their issues list instead. */}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ISSUE_CREATE) && (
            <Route path="/issue/new" component={CreateIssuePage} exact />
          )}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ISSUE_CREATE) && (
            <Route path="/issues/batch" component={BatchIssueEntryPage} exact />
          )}
          {!FinalPermissions?.includes(ALL_PERMISSIONS.ISSUE_CREATE) && (
            <Route path="/issue/new" exact render={() => <Redirect to="/issues" />} />
          )}

          <Route
            path="/issue/:shareToken/resolve"
            component={IssueResolutionPage}
            exact
          />

          {/* The legacy issue viewer is consolidated into the resolve view:
              /issue/:shareToken (old links, share links, ?g= guest links)
              redirects there, query string preserved. */}
          <Route
            path="/issue/:shareToken"
            exact
            render={({ match, location }) => (
              <Redirect to={{ pathname: `/issue/${match.params.shareToken}/resolve`, search: location.search }} />
            )}
          />

          <Route path="/exports/history/:projectId" component={ExportHistoryPage} exact />
          {(FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) ||
            FinalPermissions?.includes(ALL_PERMISSIONS.TEAM_INSIGHTS_VIEW) ||
            FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_CONTRIBUTORS_VIEW)) && (
            <Route path="/analytics" component={AnalyticsPerformancePage} exact />
          )}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) && (
            <Route
              path="/analytics/models"
              exact
              render={() => <DiffAnalyticsPage kind="model" pageTitle="Model diff analytics" />}
            />
          )}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) && (
            <Route
              path="/analytics/estimates"
              exact
              render={() => <DiffAnalyticsPage kind="est" pageTitle="Estimate diff analytics" />}
            />
          )}
          {(FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) ||
            FinalPermissions?.includes(ALL_PERMISSIONS.TIMELINE_VIEW)) && (
            <Route
              path="/analytics/revisions"
              exact
              render={() => <DiffAnalyticsPage kind="all" pageTitle="Revision diffs" />}
            />
          )}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) && (
            <Route path="/analytics/project/:projectId" component={ProjectAnalyticsPage} exact />
          )}
          {FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW) && (
            <Route path="/analytics/user/:userId" component={UserAnalyticsPage} exact />
          )}

          {FinalPermissions?.includes(
            ALL_PERMISSIONS.ENGINEERING_TRACKING_VIEW
          ) ? (
            <Route
              path="/resource-tracking"
              component={ResourceTracking}
              exact
            />
          ) : null}

          {FinalPermissions?.includes(ALL_PERMISSIONS.AFFILIATIONS_VIEW) ? (
            <Route path="/earnings" component={Earnings} exact />
          ) : null}

          <Route path="/activity-log" component={ActivityLog} exact />

          <Route
            path="/learning"
            render={() => (
              <MyApp anonymous={false} userInfoRedux={userInfoRedux} />
            )}
          />
          <Route path="/permissions" component={Permissions} exact />
          <Route path="/profile" component={Profile} exact />
          <Route path="/request_access" component={RequestAccess} exact />
          {/* Emailed links that also open for someone already signed in on
              this browser (they used to fall through to /dashboard). */}
          <Route path="/shared/areas/:token" exact render={() => <SharedResourcePage kind="areas" />} />
          <Route path="/shared/sheet/:token" exact render={() => <SharedResourcePage kind="sheet" />} />
          <Route path="/shared/schedule/:token" exact render={() => <SharedResourcePage kind="schedule" />} />
          <Route
            path="/responsible-registration/:token"
            exact
            render={({ match }) => (
              <ResponsibleRegistrationPage token={match.params.token} />
            )}
          />
          <Route
            path="/reset-password/:key/:token"
            exact
            render={({ match }) => (
              <ResetPassword key={match.params.key} />
            )}
          />
          {/* Signed in already: /authorization?next=<path> goes on to it. */}
          <Route
            path="/authorization"
            exact
            render={({ location }) => {
              let n = "";
              try { n = safeNext(new URLSearchParams(location.search || "").get("next")); } catch (e) { n = ""; }
              return <Redirect to={n || "/dashboard"} />;
            }}
          />
          <Redirect to="/dashboard" />
        </Switch>
      </div>
    );
  }, [adminFlag, maybeMainAdmin, FinalPermissions]);

  if (magicPending) {
    return (
      <div style={{ minHeight: "calc(60 * var(--vh))", display: "flex", alignItems: "center", justifyContent: "center", color: "#666", fontFamily: "Arial, sans-serif" }}>
        Signing you in from your email link...
      </div>
    );
  }

  if (maybeEmail) {
    // Permission-gated routes (/issues, /coordination pages, ...) only
    // exist once company + user permissions have loaded (the Header's
    // drawer fetches them right after sign-in). Rendering the Switch
    // before that sends any deep link (emailed links, magic sign-in,
    // login "from" path) into the catch-all redirect to /dashboard. Hold
    // the routes until permissions arrive; fall through after a few
    // seconds so a user with no permissions at all still gets a page.
    // All THREE sets must be in - FinalPermissions is their intersection,
    // and the drawer dispatches them one after another: with only company
    // (or all) loaded and user still [] the intersection was empty for one
    // render, and the catch-all sent an emailed /approval-queue link to
    // /dashboard.
    const loaded = (a) => Array.isArray(a) && a.length > 0;
    const permsLoaded = loaded(allPermissionRedux)
      && loaded(companyPermissionRedux) && loaded(usersPermissionRedux);
    // THE DESKTOP VIEWER IS NOT GATED ON A PERMISSION LOAD IT NEVER USES.
    //
    // Diagnosis by the desktop agent, 2026-09-27, verified here before
    // taking it: helpers/initUser reads the token from localStorage AT BOOT
    // and only calls initPermission if that decodes. The socketviewer token
    // arrives from the URL, inside SocketViewer, AFTER boot - so at boot
    // there is nothing to decode, initPermission never runs for that route,
    // and this gate waits out its whole timeout before reporting "Your
    // permissions did not load" on a session that is perfectly valid.
    //
    // Removing the gate here rather than loading permissions there is the
    // right way round, and it is checked rather than assumed: SOCKETVIEWER
    // READS NO PERMISSIONS ANYWHERE IN ITS TREE - no permission,
    // usePermissions, allPermission or can( in the whole directory. Calling
    // initPermission from it would fetch a set nothing reads and would make
    // the desktop viewer fail whenever that endpoint is slow, which is this
    // bug again with a longer fuse.
    const permsReady = socketviewer || permsLoaded || permsWaitExpired;
    // Expired WITHOUT the permissions is not "this user has none": it is
    // "we could not find out". Falling through would render a route tree
    // with no gated routes in it, and the catch-all would redirect a
    // signed-in user to /authorization - losing their session over one
    // bad response. Say so and offer the reload instead.
    const permsFailed = !socketviewer && permsWaitExpired && !permsLoaded;
    return (
      <div>
        {googleAnalytics4(maybeUserID)}
        <>
          {/* Header + Coordination tab strip pinned as ONE block at the top
              of every page (AppTopBars). The desktop plugin's embedded
              viewer (socketviewer) has no header on purpose. */}
          {socketviewer ? null : (
            <AppTopBars>
              <Header setModal={setModal} />
              <CoordinationTabBar />
            </AppTopBars>
          )}
          <SetPasswordNudge userInfo={userInfoRedux} />

          <MDBBox>
            <DownloadSoftwareModal
              isOpen={modal === "DownloadSoftware"}
              toggle={() => setModal("")}
            />
            {permsFailed ? (
              <div style={{
                minHeight: "calc(50 * var(--vh))", display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center", gap: 12,
                color: "#4B5563", fontFamily: "Arial, sans-serif", textAlign: "center", padding: 24,
              }}>
                <div style={{ fontSize: 16, fontWeight: 600, color: "#23343E" }}>
                  Your permissions did not load
                </div>
                <div style={{ fontSize: 13, maxWidth: 420 }}>
                  You are still signed in. The server did not answer in time, so the pages you have
                  access to could not be worked out yet.
                </div>
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  style={{
                    border: "none", background: "#23343E", color: "#fff", borderRadius: 4,
                    padding: "8px 18px", fontSize: 13, cursor: "pointer",
                  }}
                >
                  Try again
                </button>
              </div>
            ) : permsReady ? pages : (
              <div style={{ minHeight: "calc(50 * var(--vh))", display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontFamily: "Arial, sans-serif" }}>
                Loading your workspace...
              </div>
            )}
          </MDBBox>
        </>
      </div>
    );
  }

  return (
    <div>
      <DownloadSoftwareModal
        isOpen={modal === "DownloadSoftware"}
        toggle={() => setModal("")}
      />
      {googleAnalytics4(maybeUserID)}
      <Switch>
        <Route path="/privacy" exact component={Privacy} />
        <Route path="/Revit-Estimate-Plugin" exact component={RevitEstimate} />
        <Route path="/" component={Authorization} exact />
        {/* <Route path="/estimation" component={EstimationTemplate} exact /> */}
        {/* <Route
          path="/estimation/:username"
          component={EstimationTemplate}
          exact
        /> */}
        <Route path="/thank-you" component={Thankyou} exact />
        <Route path="/authorization" component={Authorization} exact />
        <Route
          path="/learning"
          render={() => (
            <>
              <Header setModal={setModal} anonymous={true} />
              <MyApp anonymous={true} />
            </>
          )}
        />
                   <Route
              path="/pricing-catalogues"
              component={PricingCatelogs}
              exact
            />
        <Route path="/market-feed" component={MarketFeed} exact />

        {/* Read-only share links. No auth on purpose: the recipient
            holds a share token and (usually) a personal guest token in
            ?g=. Sits with the other anonymous routes so the app shell
            never tries to resolve a session for them. */}
        <Route path="/shared/areas/:token" exact render={() => <SharedResourcePage kind="areas" />} />
        <Route path="/shared/sheet/:token" exact render={() => <SharedResourcePage kind="sheet" />} />
        <Route path="/shared/schedule/:token" exact render={() => <SharedResourcePage kind="schedule" />} />

        <Route
          path="/share-project/:shareId"
          exact
          render={() => <Share anonymous={true} />}
        />
        <Route
          path="/registration-user-admin/:key"
          exact
          render={({ match }) => (
            <RegistrationUserAdmin key={match.params.key} />
          )}
        />
        <Route
          path="/registration-user/:key"
          exact
          render={({ match }) => (
            <RegistrationUser key={match.params.key} />
          )}
        />
        <Route
          path="/responsible-registration/:token"
          exact
          render={({ match }) => (
            <ResponsibleRegistrationPage token={match.params.token} />
          )}
        />
        <Route
          path="/checklist/validate/:token"
          exact
          render={({ match }) => (
            <ChecklistValidatePage token={match.params.token} />
          )}
        />
        <Route
          path="/reset-password/:key/:token"
          exact
          render={({ match }) => (
            <ResetPassword key={match.params.key} />
          )}
        />
        <Route
          path="/personal-area/projects/:projectId/timelines/:timelineId/:token"
          exact
          render={({ match }) => (
            <Viewer
              projectId={match.params.projectId}
              timelineId={match.params.timelineId}
              token={match.params.token}
              personal={true}
            />
          )}
        />
        <Route
          path="/socketviewer/:projectId/:wsSessionId/:token/:companyId"
          exact
          render={({ match }) => (
            <SocketViewer
              companyId={match.params.companyId}
              projectId={match.params.projectId}
              wsSessionId={match.params.wsSessionId}
              token={match.params.token}
            />
          )}
        />

        {/* Guest share link (issue-send-link emails, ShareIssueModal):
            IssueResolutionPage handles the no-account path itself via the
            guest registration modal + publicAccess gate on the backend. */}
        <Route
          path="/issue/:shareToken"
          exact
          render={({ match, location }) => (
            <Redirect to={{ pathname: `/issue/${match.params.shareToken}/resolve`, search: location.search }} />
          )}
        />
        {/* No-account resolve link: assignment / status emails to partner
            contacts carry ?g=<guestToken>; the page swaps it for a guest
            session and works the issue (comment, markup, status) without
            a BidLight account. Public share links land here too (guest
            registration modal). */}
        <Route
          path="/issue/:shareToken/resolve"
          exact
          render={(props) => <IssueResolutionPage {...props} />}
        />

        {/* Any other deep link (assignment / status emails point at
            /issue/:shareToken/resolve, digests at /coordination/...) needs
            an account: send to login but REMEMBER the destination —
            Authorization reads location.state.from and Login pushes it
            after a successful sign-in, so the emailed link opens straight
            after login instead of dumping the user on the dashboard. */}
        <Route
          render={({ location }) => (
            <Redirect
              to={{
                pathname: "/authorization",
                state: { from: `${location.pathname}${location.search || ""}` },
              }}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default App;
